import {Link} from '@shopify/hydrogen';
import {twMerge} from 'tailwind-merge';
import {BLOG_CATEGORIES, DATA_TEST_IDS} from '~/lib/const';
import navigation from '~/lib/navigation';

export function PostCategories({
  className,
  categories,
  limit,
  replaceHistoryOnClick,
}: {
  className?: string;
  categories?: string[];
  limit?: number;
  replaceHistoryOnClick?: boolean;
}) {
  return (
    <div
      data-testid={DATA_TEST_IDS.POST_CATEGORIES}
      className={twMerge('text-gray-400 flex gap-2.5 flex-wrap', className)}
    >
      {categories?.slice(0, limit).map((category) => {
        const categoryTitle =
          BLOG_CATEGORIES.find((c) => c.handle === category)?.title ?? category;

        return (
          <Link
            key={category}
            to={navigation.blogCategory.getPath(category)}
            replace={replaceHistoryOnClick}
          >
            <div
              data-testid={DATA_TEST_IDS.CATEGORY_TITLE}
              className="text-xxs md:text-16/20 font-header font-bold tracking-wider bg-gray-200 rounded-[40px] px-3 md:px-5 py-2"
            >
              {categoryTitle}
            </div>
          </Link>
        );
      })}
    </div>
  );
}
